import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import ReactApexChart from "react-apexcharts";
import { useTranslation } from 'react-i18next';
import NoDataLayer from '../../../../Common/NoDataLayer';
import { __GapColors } from '../../../../../common/Dictionaries';
import { useRef } from 'react';

function Chart(props) {
  const { t } = useTranslation();

  const inputParam_ComponentData = props.inputParam_ComponentData !== null && props.inputParam_ComponentData !== undefined && props.inputParam_ComponentData !== "" ? props.inputParam_ComponentData : null;
  const inputParam_SetterDataserieValueChartSelected = props.inputParam_SetterDataserieValueChartSelected !== null && props.inputParam_SetterDataserieValueChartSelected !== undefined && props.inputParam_SetterDataserieValueChartSelected !== "" ? props.inputParam_SetterDataserieValueChartSelected : null;

  const inputParam_Height = props.inputParam_Height !== null && props.inputParam_Height !== undefined ? props.inputParam_Height : null;
  const inputParam_Title = props.inputParam_Title !== null && props.inputParam_Title !== undefined ? props.inputParam_Title : null;
  const inputParam_SubTitle = props.inputParam_SubTitle !== null && props.inputParam_SubTitle !== undefined ? props.inputParam_SubTitle : null;
  const inputParam_CircleColor = props.inputParam_CircleColor !== null && props.inputParam_CircleColor !== undefined ? props.inputParam_CircleColor : null;
  
  const onColumnWithGapClick = (dataPoint) => {
    setTimeout(() => {
      inputParam_SetterDataserieValueChartSelected && inputParam_SetterDataserieValueChartSelected(dataPoint)
    }, 10);
  }

  const listSeriesX = inputParam_ComponentData ? [
    {
      name: t("data-lang-lbl-field-valueReal"),
      //data: [{ x: "", y: null, gapResult: false, hidden: true, show: false }, ...inputParam_ComponentData.map(({ displayValue, gapResult, serieTime, ...item }) => { return { ...item, x:serieTime.toString() , y: displayValue, gapResult: gapResult } })],
      data: inputParam_ComponentData.map(({ displayValue, gapResult, serieTimeStr, ...item }) => { return { ...item, x: serieTimeStr.toString(), y:displayValue, gapResult: gapResult }}),
      type: "column",
    },
    {
      name: t("data-lang-lbl-field-valueGoal"),
      data: inputParam_ComponentData.map(({ valueGoal, gapResult, serieTimeStr, ...item }) => { return { ...item, x: serieTimeStr.toString(), y:valueGoal, gapResult: gapResult }}),
      type: "line",
      color: '#FF8000'
    },
    {
      name: t("data-lang-lbl-field-valueGoalPercent"),
      data: inputParam_ComponentData.map(({ valueGoalPercent, gapResult, serieTimeStr, ...item }) => { return { ...item, x:serieTimeStr.toString() , y: valueGoalPercent, gapResult: gapResult }}),
      type: "line",
      color: '#000099'
    },
  ] : [];

  const listSerieTimeY = inputParam_ComponentData ? inputParam_ComponentData.map(({ serieTimeStr }) => serieTimeStr) : []

  const listSerieNames = [
  {
    axisTicks: {
      show: true,
    },
    axisBorder: {
      show: true,
      color: '#1F7BE8'
    },
    labels: {
      style: {
        colors: '#1F7BE8',
      }
    },
    tooltip: {
      enabled: true
    },
    title: {
      text: t("data-lang-lbl-field-valueReal"),
      style: {
        color: '#1F7BE8',
      }
    }
  },
  {
    show: false,
    title: {
      text: t("data-lang-lbl-field-valueGoal"),
      style: {
        color: '#FF8000',
      }
    }
  },
  {
    axisTicks: {
      show: true,
    },
    axisBorder: {
      show: true,
      color: '#000099'
    },
    labels: {
      style: {
        colors: '#000099',
      },
      formatter: function (val) {
        return val.toFixed(0) + "%";
      }
    },
    opposite: true,
    title: {
      text: t("data-lang-lbl-field-valueGoalPercent"),
      style: {
        color: '#000099',
      }
    }   
  }];

  const chartRef = useRef(null)

  useEffect(() => {
    // Get the chart instance from the ref
    const chart = chartRef.current.chart;

    // Update the color of the legend item for Series 1
    chart.updateOptions({
      legend: {
        markers: {
          fillColors: ['#1F7BE8', '#FF8000', '#000099'],
        },
      },
    });
  }, []);

  return (
          <>
            {
              inputParam_ComponentData ?
              <>
                <Col>
                  {
                    (inputParam_Title || inputParam_SubTitle) &&
                    <Row>
                      {
                        inputParam_Title &&
                        <>
                          <Col className='col-auto me-auto'>
                            {
                              inputParam_CircleColor &&
                              <div className="rounded-circle border" style={{width: "25px", height: "25px", backgroundColor: __GapColors.find(x => x.key === inputParam_CircleColor).text}}></div>
                            }
                          </Col>
                          <Col>
                            <>
                              {
                                inputParam_Title
                              }
                              {
                                inputParam_SubTitle && inputParam_SubTitle
                              }
                            </>
                          </Col>
                        </>
                      }
                    </Row>
                  }
                  <Row>
                  <ReactApexChart 
                    ref={chartRef}
                    type="line"
                    series={listSeriesX}
                    options={{
                      colors: [
                        function ({ value, seriesIndex, dataPointIndex }) {
                          let dataPoint = listSeriesX[seriesIndex].data[dataPointIndex];

                          if (seriesIndex === 0) {
                            if (dataPoint.gapResult) {
                              //return '#FF0000';
                              return __GapColors.find(x => x.key === dataPoint.colorGap).text;
                            }
                            else {
                              return '#1F7BE8';
                            }
                          }
                          else if (seriesIndex === 1) {
                            return '#FF8000';
                          }
                          else {
                            return '#000099';
                          }
                      }],
                      chart: {
                        type: 'line',
                        stacked: false,
                        events: {
                          dataPointSelection: (event, chartContext, config) => { 
                            let dataPoint = listSeriesX[config.seriesIndex].data[config.dataPointIndex]; 
                            onColumnWithGapClick(dataPoint)                                
                          }
                        }
                      },
                      dataLabels: {
                        enabled: false
                      },
                      stroke: {
                        width: [3, 3, 3]
                      },
                      xaxis: {
                        categories: listSerieTimeY,
                      },
                      yaxis: listSerieNames,
                      tooltip: {
                        fixed: {
                          enabled: true,
                          position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
                          offsetY: 30,
                          offsetX: 60
                        },
                      },
                      legend: {
                        horizontalAlign: 'center',
                        offsetX: 40
                      }
                    }}
                    events={{
                      mounted: (chartContext, config) => {
                        chartContext.selection.setSeriesSelected([1]);
                      },
                    }}
                    height={inputParam_Height !== null ? inputParam_Height : 350}
                  />
                  </Row>
                </Col>
              </> : <NoDataLayer display={ true } />
            } 
          </>
  );
}

export default Chart;